import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  ConnectedService,
  ConnectedServiceData,
} from '@lyrahealth-inc/shared-app-logic/src/features/connectedService/types'

import { getConnectedServicesData, updateConnectedServiceData } from '../../common/http/data/connectedService'

export const GET_CONNECTED_SERVICES = 'GET_CONNECTED_SERVICES'
export const UPDATE_CONNECTED_SERVICE = 'UPDATE_CONNECTED_SERVICE'

export const getConnectedServices = createAsyncThunk<ConnectedServiceData[], string>(
  GET_CONNECTED_SERVICES,
  async (lyraId: string, { rejectWithValue }) => {
    try {
      const response = await getConnectedServicesData(lyraId)
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export interface UpdateConnectedServiceArgs {
  lyraId: string
  service: ConnectedService
  consentToShare: boolean
}

export const updateConnectedService = createAsyncThunk<ConnectedServiceData, UpdateConnectedServiceArgs>(
  UPDATE_CONNECTED_SERVICE,
  async ({ lyraId, service, consentToShare }, { rejectWithValue }) => {
    try {
      const response = await updateConnectedServiceData(lyraId, service, consentToShare)
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const RESET_CONNECTED_SERVICES_LOADING_STATUS = 'RESET_CONNECTED_SERVICES_LOADING_STATUS'
export const resetConnectedServicesLoadingStatus = () => ({ type: RESET_CONNECTED_SERVICES_LOADING_STATUS })

export const GET_CONNECTED_SERVICES_FULFILLED = getConnectedServices.fulfilled.type
export const GET_CONNECTED_SERVICES_PENDING = getConnectedServices.pending.type
export const GET_CONNECTED_SERVICES_REJECTED = getConnectedServices.rejected.type
export const UPDATE_CONNECTED_SERVICE_FULFILLED = updateConnectedService.fulfilled.type
